import React, { FC } from "react";

import { Column, DesktopMenuList, Row } from "../../../components";

const DMBrandsFlyout: FC = () => {
  return (
    <Row>
      <Column xs={2}>
        <DesktopMenuList
          titleLink={{ text: "A-Z LIST Of Brands" }}
          linksItems={[{ text: "View all brands" }]}
        />
      </Column>
      <Column>
        <DesktopMenuList
          classes={{ root: "nav-menu--columns" }}
          linksItems={[
            { text: "Adidas" },
            { text: "Alpina" },
            { text: "Arena" },
            { text: "Asics" },
            { text: "Atomic" },
            { text: "Black Diamond" },
            { text: "Blackroll" },
            { text: "Bollé" },
            { text: "Brooks" },
            { text: "Buff" },
            { text: "Dachstein" },
            { text: "Dalbello" },
            { text: "Deuter" },
            { text: "Dynafit" },
            { text: "Eisbär" },
            { text: "Energetics" },
            { text: "Firefly" },
            { text: "Fischer" },
            { text: "Fjällräven" },
            { text: "Garmin" },
            { text: "KTM" },
            { text: "LedLenser" },
            { text: "Leki" },
            { text: "Löffler" },
            { text: "Lowa" },
            { text: "Mammut" },
            { text: "Martini" },
            { text: "McKinley" },
            { text: "Meindl" },
            { text: "Millet" },
            { text: "O'Neill" },
            { text: "Odlo" },
            { text: "Ortovox" },
          ]}
        />
      </Column>
    </Row>
  );
};

export default DMBrandsFlyout;
